import React, {useState} from 'react';

const LoginContext = React.createContext({
    isOldCardProcess: false,    
    isBioIdClicked: false,
    isScClicked: false,
    isPassKey: false,
    isPassKeyMarket: false,  
    isAccount: false,       
    showRegFormOptions:false,    
    showSideNote:true,
    loginNeededInfo: [''],
    currentState:"",
    enrollmentSmsOtp:false,
    isSuccess: false,
    devMode: false,
    preRegScreenCollection:{
        initial: 'initial',
        introduction: 'introduction',
        mainOptions: 'mainOptions',
        alternativeOptions: 'alternativeOptions',
        binuyShikun: 'binuyShikun',
        summaryOptions: 'summaryOptions',
        bioIdFirst: 'bioIdFirst',
        bioIdCode: 'bioIdCode',
        smartCardReader: 'smartCardReader',
        servicePositions: 'servicePositions',
        pibaNoCard:'pibaNoCard',
        pibaNoCode: 'pibaNoCode'
    },    
    summaryRegOptions: [''],
    skipMainRegForm:false,
    isMarketfocus:false,
    PreRegUser: [''],
    toggleCard: () => {},    
    bioIdSelected:() => {},
    scSelected:() => {},    
    passkeyMarketSelected: () => {},    
    setLoginNeededInfo: (neededInfo:any) => {},
    displayRegForm: (show:boolean) => {},    
    displaySideNote: (show:boolean) => {},
    setCurrentState: (state:string) => {},  
    setEnrollmentSmsOtp:() => {},
    setSuccess: () => {},            
    updateSummaryRegOptions: (newSummaryArr:string[]) => {},
    setSkipMainRegForm: (skip:boolean) => {},
    toggleMarketFocus:() => {},
    updatePreRegUser: (preRegUserArr: string[]) => {}, 
    toggleAccountView:() => {}   
});

export const LoginContextProvider = props => {
    const [isOldCard, setIsOldCard] = useState(false);
    const [bioIdShow, setBioIdShow] = useState(false);
    const [scShow, setScShow] = useState(false);
    const [passkeyShow, setPasskeyShow] = useState(false);
    const [passkeyMarketShow, setPasskeyMarketShow] = useState(false);    
    const [logNeededInf, setLogNeededInf] = useState([]);
    const [displayRegOptions, setDisplayRegOptions] = useState(false);
    const [showSideNoteZone,setShowSideNoteZone] = useState(true) ;
    const [currentLoginState,setCurrentLoginState] = useState("");    
    const [isProcessSucceeded, setIsProcessSucceeded] = useState(false);
    const [isEnrollmentSmsStep,setIsEnrollmentSmsStep] = useState(false);        
    const [summaryFields,setSummaryFields] = useState<string[]>([]);
    const [skipPreRegFirstStep,setSkipPreRegFirstStep] = useState(false);
    const [marketView,setMarketView] = useState(false);
    const [preRegUserDetails,setPreRegUserDetails] = useState<string[]>([]);
    const [accountShow, setAccountShow] = useState(false);
    

    const toggleCardProcess = () => {
        setIsOldCard(!isOldCard);        
    };
    
    const handleBioIdSelected = () => {
        setBioIdShow(true);
        setScShow(false);
        setPasskeyShow(false);
        setPasskeyMarketShow(false);
    };

    const handleScSelected = () => {
        setScShow(true);
        setBioIdShow(false);
        setPasskeyShow(false);
        setPasskeyMarketShow(false);
    };
   
    const handlePasskeyMarketSelected = () => {
        setPasskeyMarketShow(true);
        setPasskeyShow(false);
        setScShow(false);
        setBioIdShow(false);
    };   

    const handleNeededInfoUpdate = (neededInfo:any) => {
        setLogNeededInf(neededInfo);
    };

    const updateDisplayRegOptions = (show:boolean) => {
        setDisplayRegOptions(show);
    };
   
    const handleSideNoteChange = (show:boolean) =>{
        setShowSideNoteZone(show);
    };

    const handleStateUpdate = (newState:string) => {
        setCurrentLoginState(newState);
    };
    
    const onProcessSucceeded = () => {
        setIsProcessSucceeded(true);
    };

    const handleEnrollmentSmsStep = () => {
        setIsEnrollmentSmsStep(true);
    };
          
    const handleUpdateUserRegOptions = (newArr:any) => {
        setSummaryFields(newArr);
    };

    const handleUpdatePreRegUserDetails = (userDetails:any) => {
        setPreRegUserDetails(userDetails);
    }

    const handleSkipPreRegMainStep = (skip:boolean) =>{
        setSkipPreRegFirstStep(skip);
    };

    const handleMarketView = () => {
        setMarketView(!marketView);
    };

    const handleAccountView = () => {
        setAccountShow(!accountShow);
    };
   
    return (
        <LoginContext.Provider 
            value = {{
                isOldCardProcess: isOldCard,               
                isBioIdClicked: bioIdShow,
                isScClicked: scShow,
                isPassKey: passkeyShow,
                isPassKeyMarket: passkeyMarketShow, 
                isAccount: accountShow,                               
                loginNeededInfo: logNeededInf,
                showRegFormOptions: displayRegOptions,                
                showSideNote: showSideNoteZone,
                currentState: currentLoginState,                
                enrollmentSmsOtp : isEnrollmentSmsStep,
                isSuccess: isProcessSucceeded,                
                devMode: false,
                preRegScreenCollection:{
                    initial: 'initial',
                    introduction: 'introduction',
                    mainOptions: 'mainOptions',
                    alternativeOptions: 'alternativeOptions',
                    binuyShikun: 'binuyShikun',
                    summaryOptions: 'summaryOptions',
                    bioIdFirst: 'bioIdFirst',
                    bioIdCode: 'bioIdCode',
                    smartCardReader: 'smartCardReader',
                    servicePositions: 'servicePositions',
                    pibaNoCard: 'pibaNoCard',
                    pibaNoCode: 'pibaNoCode'
                },                
                summaryRegOptions: summaryFields,
                skipMainRegForm: skipPreRegFirstStep,
                isMarketfocus: marketView,
                PreRegUser: preRegUserDetails,
                toggleCard: toggleCardProcess,                 
                bioIdSelected: handleBioIdSelected,
                scSelected : handleScSelected,                
                passkeyMarketSelected: handlePasskeyMarketSelected,                
                displayRegForm: updateDisplayRegOptions,                
                setLoginNeededInfo: handleNeededInfoUpdate,
                displaySideNote: handleSideNoteChange,
                setCurrentState: handleStateUpdate,                
                setEnrollmentSmsOtp : handleEnrollmentSmsStep,
                setSuccess: onProcessSucceeded,                                                
                updateSummaryRegOptions: handleUpdateUserRegOptions,
                setSkipMainRegForm: handleSkipPreRegMainStep,
                toggleMarketFocus: handleMarketView,
                updatePreRegUser: handleUpdatePreRegUserDetails,
                toggleAccountView: handleAccountView              
            }}
        >
           {props.children}
        </LoginContext.Provider>
    );
}

export default LoginContext;